(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('offerService', offerService);

    offerService.$inject = ['$http', 'CONFIG', 'messageService', 'locationService'];


    function offerService($http, CONFIG, messageService, locationService){
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FLIGHT_CONTROL + '/' + CONFIG.API + '/offers';
        var service = {
            getOffers: getOffers,
            saveOffer: saveOffer,
            getOffer: getOffer,
            deleteOffer: deleteOffer,
            updateOffer: updateOffer,
            thereOffer: thereOffer
        };

        return service;

        function getOffers(page, size, detailed, originId) {
            detailed = (detailed != undefined) ? true : false;
            var sort = '&sort=originAirport.city.region.name,asc';

            if (originId !== null) {
                var url = (originId == 0)
                    ? '/page?page=' + page + '&size=' + size + "&detailed=" + detailed + sort
                    : '/page?page=' + page + '&size=' + size + "&detailed=" + detailed + '&originId=' + originId + sort;

                return $http.get(urlBase + url)
                    .then(function(response) {
                        return response;
                    })
                    .catch(function() {
                        messageService.findAllError('');
                    });

            } else {
                return locationService.getFirstId().then(function(firstId) {
                    var url = '/page?page=' + page + '&size=' + size + "&detailed=" + detailed + '&originId=' + firstId + sort;

                    return $http.get(urlBase + url)
                        .then(function(response) {
                            return response;
                        });
                }).catch(function() {
                    messageService.findAllError('');
                });
            }
        }

        function saveOffer(offer, params) {
            return $http.post(urlBase, offer)
                .then(function(response){
                    messageService.register('offers', params);
                    return response;
                })
                .catch(function(){
                    messageService.registerError('offers', params);
                });
        }

        function getOffer(offerId, detailed){
            detailed = (detailed != undefined) ? true : false;
            return $http.get(urlBase + "/" + offerId + '?detailed=' + detailed)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAError('offers');
                });
        }

        function deleteOffer(offerId){
            return $http.delete(urlBase + "/" + offerId)
                .then(function(response){
                    messageService.registerDelete('offers');
                    return response;
                })
                .catch(function(){
                    messageService.registerDeleteError('offers');
                });
        }

        function updateOffer(offer, offerId, params) {
            return $http.put(urlBase + "/" + offerId, offer)
                .then(function(response){
                    messageService.registerUpdate('offers', params);
                    return response;
                })
                .catch(function(){
                    messageService.registerUpdateError('offers', params);
                });
        }
        
        function thereOffer(originId, destinationId) {
            return $http.get(urlBase + '/thereOriginDestiny/' + originId + '/' + destinationId, {headers: {'Loading-Overlay': false}})
                .then(function(response){
                    return response; 
                })
                .catch(function() {
                    messageService.findAError('');
                });
        }
    }
})();
